import { useState, useEffect, useRef } from "react";

const EmojiSidebar = ({ emojis, onSelectEmoji }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null); // Reference to sidebar to prevent accidental close

  useEffect(() => {
    // Close sidebar when clicking outside
    const handleClickOutside = (event) => {
      if (isOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const filteredEmojis = emojis.filter(({ emoji, name }) =>
    emoji.includes(searchTerm) || name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {/* Open Menu Button (hidden when menu is open) */}
      {!isOpen && (
        <button
          className="fixed top-16 -left-1 bg-blue-500 text-white p-2 rounded-md md:hidden z-40"
          onClick={() => setIsOpen(true)}
        >
          ☰ Emojis
        </button>
      )}

      {isOpen && <div className="fixed inset-0 bg-black opacity-30 z-40 md:hidden" onClick={() => setIsOpen(false)}></div>}

      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`fixed inset-y-0 left-0 w-64 bg-gray-100 p-4 border-r shadow-lg transform transition-transform duration-300 md:relative md:w-1/4 z-50 ${
          isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
        }`}
      >
        {/* Close Button (✖) in the Top Right Corner */}
        <button
          className="absolute top-4 right-4 text-gray-700 text-2xl md:hidden"
          onClick={() => setIsOpen(false)}
        >
          ✖
        </button>

        <h2 className="text-lg font-bold mb-4 text-center">Emojis Left</h2>

        {/* Search bar */}
        <input
          type="text"
          placeholder="🔎 Search emoji..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-2 mb-4 border rounded"
        />

        {/* Emoji list */}
        <div className="grid grid-cols-5 gap-2 overflow-y-auto max-h-[75vh] md:max-h-[85vh] pr-2">
          {filteredEmojis.length > 0 ? (
            filteredEmojis.map(({ emoji }, index) => (
              <button
                key={index}
                onClick={() => {
                  onSelectEmoji(emoji);
                  setIsOpen(false); // Close sidebar when selecting an emoji
                }}
                className="text-2xl p-2 hover:bg-gray-200 rounded"
              >
                {emoji}
              </button>
            ))
          ) : (
            <p className="text-gray-500 col-span-5 text-center">😕 No match or already taken</p>
          )}
        </div>
      </div>
    </>
  );
};

export { EmojiSidebar };
